import dayjs from 'dayjs';

export function getStrLength(strSrc: string | null | undefined): number {
  if (!strSrc) return 0;
  let len = 0;
  for (const char of strSrc) {
    // マルチバイト文字（encodeURIComponent で4バイト以上）は2としてカウント
    len += encodeURIComponent(char).length > 3 ? 2 : 1;
  }
  return len;
}

export function multiByteSubStr(str: string, length: number): string {
  let isSlice = false;

  while (getStrLength(str) > length) {
    str = str.slice(0, str.length - 1);
    isSlice = true;
  }

  if (isSlice) {
    str += '...';
  }

  return str;
}

/* グラフの日付整形 */
export function formatDateLabel(dateLabel: string[]): string[] {
  const ret: string[] = [];
  for (let i = 0; i < dateLabel.length; i++) {
    ret.push(dayjs(dateLabel[i]).format('YYYY/MM/DD'));
  }
  return ret;
}

export function sumValues(data: number[]): number {
  return Object.values(data).reduce((a: number, x: number) => (a += x), 0);
}

export function sumCommaValues(data: { string: string }): number {
  return Object.values(data)
    .map((val) => Number(val.split(',')[1]))
    .reduce((a: number, x: number) => (a += x), 0);
}

export function isBussiness(url: string): boolean {
  if (typeof url !== 'string') {
    return false;
  }
  url =
    url.indexOf('mtest.stroly.com') !== -1 ? url.replace('mtest', 'm') : url;
  return url.indexOf('m.stroly.com') !== -1;
}

export function isDevEnv(url: string): boolean {
  if (typeof url !== 'string') {
    return false;
  }
  // マッチするURLパターンの例
  // - https?://localhost
  // - https?://stroly-viewer-preview
  // - もしくはIPv4アドレス（0.0.0.0から255.255.255.255まで）
  return !!url.match(
    /^https?:\/\/(localhost|stroly-viewer-preview|((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9]))/i,
  );
}

export function isNumberStr(str: string): boolean {
  return Number.isFinite(Number(str));
}
